module.exports = __webpack_public_path__ + "media/newstyle/images/icon-mini-book-orange-272de97e38e546eef6af6e9acc9306be.svg";